/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Email_On_Way_HeadingInputs */

const en_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A login email is on the way`)
};

const id_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email masuk sedang dalam perjalanan`)
};

const ms_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emel log masuk sedang dalam perjalanan`)
};

const ca_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un correu de sessió està en camí.`)
};

const cs_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email pro přihlášení je na cestě`)
};

const da_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En login-e-mail er på vej`)
};

const de_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Anmelde-E-Mail ist unterwegs`)
};

const et_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisselogimise e-post on teel`)
};

const es_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un correo de inicio de sesión está en camino`)
};

const fr_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un e-mail de connexion va vous être envoyé.`)
};

const hr_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail za prijavu je na putu.`)
};

const it_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti abbiamo inviato un'email di accesso`)
};

const lv_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piesakīšanās e-pasts ir ceļā.`)
};

const lt_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisijungimo el. laiškas jau pakeliui`)
};

const hu_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy bejelentkezési email úton van`)
};

const nl_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is een inlog-e-mail onderweg`)
};

const nb_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innloggingslenken er på vei til innboksen din`)
};

const pl_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail do zalogowania jest w drodze`)
};

const pt_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um e-mail de login está a caminho.`)
};

const ro_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un e-mail de autentificare este pe drum`)
};

const sk_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail s prihlásením je na ceste`)
};

const sl_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-poštno sporočilo za prijavo je na poti`)
};

const fi_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjautumissähköposti on matkalla.`)
};

const sv_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett inloggningsmail är på väg`)
};

const vi_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một email đăng nhập đang trên đường`)
};

const tr_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir oturum açma e-postası yolda`)
};

const el_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένα email σύνδεσης είναι καθοδόν`)
};

const bg_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имейл за вход е на път.`)
};

const ru_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Письмо для входа в систему уже в пути.`)
};

const sr_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Емаил за пријаву је на путу`)
};

const uk_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лист для входу в дорозі`)
};

const ka_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ავტორიზაციის მეილი გზიდან არის.`)
};

const hi_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक लॉगिन ईमेल रास्ते में है`)
};

const th_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมลเข้าสู่ระบบกำลังเดินทาง`)
};

const ko_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 이메일 전송 완료`)
};

const zh_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录电子邮件正在发送中`)
};

const zh_tw_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入電子郵件已發送`)
};

const ja_login_email_on_way_heading = /** @type {(inputs: Login_Email_On_Way_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン用メールを送信しました`)
};

/**
* | output |
* | --- |
* | "A login email is on the way" |
*
* @param {Login_Email_On_Way_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const login_email_on_way_heading = /** @type {((inputs?: Login_Email_On_Way_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Email_On_Way_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_login_email_on_way_heading(inputs)
	if (locale === "ms") return ms_login_email_on_way_heading(inputs)
	if (locale === "ca") return ca_login_email_on_way_heading(inputs)
	if (locale === "cs") return cs_login_email_on_way_heading(inputs)
	if (locale === "da") return da_login_email_on_way_heading(inputs)
	if (locale === "de") return de_login_email_on_way_heading(inputs)
	if (locale === "et") return et_login_email_on_way_heading(inputs)
	if (locale === "es") return es_login_email_on_way_heading(inputs)
	if (locale === "fr") return fr_login_email_on_way_heading(inputs)
	if (locale === "hr") return hr_login_email_on_way_heading(inputs)
	if (locale === "it") return it_login_email_on_way_heading(inputs)
	if (locale === "lv") return lv_login_email_on_way_heading(inputs)
	if (locale === "lt") return lt_login_email_on_way_heading(inputs)
	if (locale === "hu") return hu_login_email_on_way_heading(inputs)
	if (locale === "nl") return nl_login_email_on_way_heading(inputs)
	if (locale === "nb") return nb_login_email_on_way_heading(inputs)
	if (locale === "pl") return pl_login_email_on_way_heading(inputs)
	if (locale === "pt") return pt_login_email_on_way_heading(inputs)
	if (locale === "ro") return ro_login_email_on_way_heading(inputs)
	if (locale === "sk") return sk_login_email_on_way_heading(inputs)
	if (locale === "sl") return sl_login_email_on_way_heading(inputs)
	if (locale === "fi") return fi_login_email_on_way_heading(inputs)
	if (locale === "sv") return sv_login_email_on_way_heading(inputs)
	if (locale === "vi") return vi_login_email_on_way_heading(inputs)
	if (locale === "tr") return tr_login_email_on_way_heading(inputs)
	if (locale === "el") return el_login_email_on_way_heading(inputs)
	if (locale === "bg") return bg_login_email_on_way_heading(inputs)
	if (locale === "ru") return ru_login_email_on_way_heading(inputs)
	if (locale === "sr") return sr_login_email_on_way_heading(inputs)
	if (locale === "uk") return uk_login_email_on_way_heading(inputs)
	if (locale === "ka") return ka_login_email_on_way_heading(inputs)
	if (locale === "hi") return hi_login_email_on_way_heading(inputs)
	if (locale === "th") return th_login_email_on_way_heading(inputs)
	if (locale === "ko") return ko_login_email_on_way_heading(inputs)
	if (locale === "zh") return zh_login_email_on_way_heading(inputs)
	if (locale === "zh-tw") return zh_tw_login_email_on_way_heading(inputs)
	if (locale === "ja") return ja_login_email_on_way_heading(inputs)
	return en_login_email_on_way_heading(inputs)
});